import type { ReactNode, SVGProps } from 'react';
import { TemplateId } from '@types';
import cn from '@utils/cn';
import useEditingStore from '@hooks/useEditingStore';
import { $tourData } from '@stores/dataStores';
import { $editingUIColor } from '@stores/editingStores';
import useToggle from '@hooks/useToggle';
import { getTemplateConfig } from '@utils/templateConfig';

export interface TProjectIconChildrenProps {
  color: string;
}

export interface TProjectIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  children: (props: TProjectIconChildrenProps) => ReactNode;
}

export function TProjectIcon({
  children,
  className,
  size = 24,
  ...rest
}: TProjectIconProps) {
  const ui = useEditingStore({
    $data: $tourData,
    dataFn: (state) =>
      state.config?.ui ??
      getTemplateConfig(TemplateId.project)('uiColor') ??
      {},
    $editing: $editingUIColor.store,
  });
  const cx = cn('select-none', className);
  const color = ui.fontColor || '';
  const hoverColor = ui.fontAvtiveColor || '';
  const isHovered = useToggle(false);
  const iconColor = isHovered.isOn ? `rgba(${hoverColor})` : `rgba(${color})`;
  return (
    <svg
      width={size}
      height={size}
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={cx}
      {...rest}
      onMouseEnter={isHovered.on}
      onMouseLeave={isHovered.off}
    >
      {children({ color: iconColor })}
    </svg>
  );
}
